import React from "react"
import { CarouselComponent } from "../CarouselComponent"

export const TidalWelcomeComponent = () => {
  return (
    <CarouselComponent height="100vh" bgPosition="top center" images={[getLandingImage()]}>
      <div className="row">
        <div className="col mx-auto">
          <p className="text-center title-paramount">Access your free TIDAL promotion below</p>
        </div>
      </div>
    </CarouselComponent>
  )
}

const getLandingImage = () => {
  let isDesktop = window.matchMedia && window.matchMedia("(min-width: 768px)").matches
  if (isDesktop) { return "/images/Tidal/landing_desktop.png" } else { return "/images/Tidal/landing_mobile.png" }
}
